:host {
  display: flex;
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  margin-bottom: var(--cms-components-mb);

  @include cms-base-font;

  padding: 0;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box;
}

/* container */
.category-slider-container {
  width: 100%;
  overflow-y: hidden;
  box-sizing: border-box;
  padding: 2rem 0;
  margin: 0;
}

/* Carousel */
.carousel {
  margin: 0 auto;
  visibility: visible;

  .splide-inner {
    position: relative;

    .track {
      position: relative;
      z-index: 0;
      overflow: hidden;

      .list {
        display: flex;
        margin: 0;
        padding: 0;
        list-style-type: none;
        width: 100%;
      }
    }
  }
}

/* Single slide */
.slide {
  box-sizing: border-box;
  margin: 0 0.75rem 0 0;
  flex-shrink: 0;
  background: #fff;
  width: calc(68.125rem / 4.5);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;

  .cta {
    overflow: hidden;
    height: 100%;
    display: grid;
    align-content: space-between;
    text-decoration: none;

    .slide-container {
      text-align: center;
      padding-bottom: 0.75rem;

      img {
        width: 100%;
        border-style: none;
        height: auto;
        max-width: 100%;
        vertical-align: middle;
      }
    }

    .button-wrapper {
      margin-bottom: 1rem;
      display: flex;
      justify-content: center;

      .button {
        text-transform: uppercase;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        font-family: 'TradeGothic';
        padding: 6px;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: css-var(border-radius-0125);
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        background-color: transparent;
        @include generateBorder(
          '0125',
          solid,
          semanticColors-container-medium-border
        );

        span {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

/* Arrows */
.arrows-wrapper {
  .splide__arrow {
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    @include generateBorder('006', solid, theme-border-color);

    padding: 0;
    background: transparent;
    height: 2.375rem;
    width: 2.375rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &.arrow-prev {
      left: -4em;
      text-decoration: none;
    }

    &.arrow-next {
      right: -4em;
      text-decoration: none;
    }

    &.arrow-next[disabled],
    &.arrow-prev[disabled] {
      pointer-events: none;
      opacity: 0.4;
    }

    path {
      fill: css-var(theme-svg-color);
    }
  }
}

@media (width <= 480px) {
  .slide {
    width: calc((100vw - 2rem) / 1.5);
  }
}

@media (width >= 481px) and (width <= 767px) {
  .slide {
    width: calc((100vw - 2rem) / 2.5);
  }
}

@media (width >= 768px) and (width <= 991px) {
  .carousel {
    max-width: 41rem;
  }

  .slide {
    width: calc(41rem / 3.5);
  }
}

@media (width >= 992px) and (width <= 1199px) {
  .carousel {
    max-width: 55rem;
  }

  .slide {
    width: calc(55rem / 3.5);
  }
}

@media (width >= 1200px) {
  .carousel {
    max-width: 68.125rem;
  }
}

@media (width <= 767px) {
  .arrows-wrapper {
    display: none;
  }
}

/* Fallback for invalid configuration */
.invalid-configuration {
  color: css-var(theme-text-color);
}
